import { schema } from 'normalizr'

const restaurant = new schema.Entity('restaurants')

export default restaurant
